import { render, staticRenderFns } from "./PopupEditProjectMember.vue?vue&type=template&id=6cfebaf5"
import script from "./PopupEditProjectMember.vue?vue&type=script&lang=ts"
export * from "./PopupEditProjectMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports